import "./Footer.css";
import { FaLinkedin, FaGithub } from "react-icons/fa";
export const Footer = () => {
  return (
    <div className="footer">
      <span className="footer__title">Keep in touch</span>
      <div className="socials">
        <a href="https://www.linkedin.com/in/gaurvi-rajwanshi-774a111b7/">
          <FaLinkedin size={25} />
        </a>
        <a href="https://github.com/gaurvirajwanshi">
          <FaGithub size={25} />
        </a>
      </div>
      Coded with &lt;/&gt; by Gaurvi
    </div>
  );
};
